export interface FormatInsertRule {
  id?: string
  name: string
  description?: string
  keywords: string[]
  target_section: SoapSection
  insert_text: string
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export type SoapSection =
  | 'subjectives'
  | 'objectives'
  | 'assessments'
  | 'educational_plans'
  | 'care_plans'
  | 'observational_plans'

export const soapSectionLabels: Record<SoapSection, string> = {
  subjectives: 'S: 主観的情報',
  objectives: 'O: 客観的情報',
  assessments: 'A: アセスメント',
  educational_plans: 'EP: 教育プラン',
  care_plans: 'CP: ケアプラン',
  observational_plans: 'OP: 観察プラン',
}

export interface FormatInsertRuleListResponse {
  count: number
  next: string | null
  previous: string | null
  results: FormatInsertRule[]
}
